module.exports = __webpack_public_path__ + "img/dataAssetBlue.5da5bdcb.png";